/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { MatiereAPointerDto } from '../models/matiere-a-pointer-dto';
import { TypeDechetDto } from '../models/type-dechet-dto';


/**
 * Fonctions de gestion des matières à pointer
 */
@Injectable({
  providedIn: 'root',
})
export class MatieresAPointerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation matiereAPointerGet
   */
  static readonly MatiereAPointerGetPath = '/api/matiere-a-pointer/{id}';

  /**
   * Renvoie la matière à pointer spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAPointerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAPointerGet$Response(params: {

    /**
     * Identifiant de la matière à pointer
     */
    id: number;
  }): Observable<StrictHttpResponse<MatiereAPointerDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAPointerService.MatiereAPointerGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MatiereAPointerDto>;
      })
    );
  }

  /**
   * Renvoie la matière à pointer spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAPointerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAPointerGet(params: {

    /**
     * Identifiant de la matière à pointer
     */
    id: number;
  }): Observable<MatiereAPointerDto> {

    return this.matiereAPointerGet$Response(params).pipe(
      map((r: StrictHttpResponse<MatiereAPointerDto>) => r.body as MatiereAPointerDto)
    );
  }

  /**
   * Path part for operation matiereAPointerPut
   */
  static readonly MatiereAPointerPutPath = '/api/matiere-a-pointer/{id}';

  /**
   * Met à jour la matière à pointer spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAPointerPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerPut$Response(params: {

    /**
     * Identifiant de la matière à pointer à mettre à jour
     */
    id: number;

    /**
     * Matière à pointer
     */
    body: MatiereAPointerDto
  }): Observable<StrictHttpResponse<MatiereAPointerDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAPointerService.MatiereAPointerPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MatiereAPointerDto>;
      })
    );
  }

  /**
   * Met à jour la matière à pointer spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAPointerPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerPut(params: {

    /**
     * Identifiant de la matière à pointer à mettre à jour
     */
    id: number;

    /**
     * Matière à pointer
     */
    body: MatiereAPointerDto
  }): Observable<MatiereAPointerDto> {

    return this.matiereAPointerPut$Response(params).pipe(
      map((r: StrictHttpResponse<MatiereAPointerDto>) => r.body as MatiereAPointerDto)
    );
  }

  /**
   * Path part for operation matiereAPointerDelete
   */
  static readonly MatiereAPointerDeletePath = '/api/matiere-a-pointer/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAPointerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAPointerDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAPointerService.MatiereAPointerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAPointerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAPointerDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.matiereAPointerDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation matiereAPointerPost
   */
  static readonly MatiereAPointerPostPath = '/api/matiere-a-pointer';

  /**
   * Crée la matière à pointer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAPointerPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerPost$Response(params: {

    /**
     * Matière à pointer
     */
    body: MatiereAPointerDto
  }): Observable<StrictHttpResponse<TypeDechetDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAPointerService.MatiereAPointerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetDto>;
      })
    );
  }

  /**
   * Crée la matière à pointer.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAPointerPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerPost(params: {

    /**
     * Matière à pointer
     */
    body: MatiereAPointerDto
  }): Observable<TypeDechetDto> {

    return this.matiereAPointerPost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetDto>) => r.body as TypeDechetDto)
    );
  }

  /**
   * Path part for operation matiereAPointerDesactivate
   */
  static readonly MatiereAPointerDesactivatePath = '/api/matiere-a-pointer/{id}/desactivate';

  /**
   * Désactive la matière à pointer spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAPointerDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerDesactivate$Response(params: {

    /**
     * Identifiant la matière à pointer à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: MatiereAPointerDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAPointerService.MatiereAPointerDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive la matière à pointer spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAPointerDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerDesactivate(params: {

    /**
     * Identifiant la matière à pointer à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: MatiereAPointerDto
  }): Observable<number> {

    return this.matiereAPointerDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation matiereAPointerGetList
   */
  static readonly MatiereAPointerGetListPath = '/api/matiere-a-pointer/list';

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAPointerGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAPointerGetList$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAPointerService.MatiereAPointerGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAPointerGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAPointerGetList(params?: {
  }): Observable<void> {

    return this.matiereAPointerGetList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation matiereAPointerLoadList
   */
  static readonly MatiereAPointerLoadListPath = '/api/matiere-a-pointer/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAPointerLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAPointerService.MatiereAPointerLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAPointerLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAPointerLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.matiereAPointerLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
